<div class="-main-header-wrapper">
  <header class="header">
    <div class="px-3 pt-2">
      <div class="d-flex top-label-white" *ngIf="_service.getConfiguration('tenantGenericConfig')?.tenantTagLine">
        {{_service.getConfiguration('tenantGenericConfig')?.tenantTagLine}}
      </div>
      <nav class="navbar navbar-light navbar-expand-md bg-faded justify-content-center position-sticky w-100 pt-0">
        <a [routerLink]="[]" (click)="toggleSidenav()"><img src="../../../../assets/images/toggle-header-idec.svg"
            alt="Hamburger"></a>
        <a class="navbar-brand d-flex align-items-center w-50 mr-auto px-4">
          <div class="d-flex align-items-center mr-3 cursor img-border-r" [ngClass]="{'image-size': _service.getConfiguration('tenantGenericConfig')?.tenant === 'IOC'}" (click)="loadLaunch()">
            <span *ngIf="!_service.getConfiguration('tenantGenericConfig')?.tenantLogo"><span
                class="login-logo-1">UST</span> <span class="login-logo-2">iDEC</span></span>
            <span *ngIf="_service.getConfiguration('tenantGenericConfig')?.tenantLogo" class="prl-15">
              <img alt="logo" class="logo-h-30" *ngIf="_service.getConfiguration('tenantGenericConfig')?.tenant !== 'IOC'" [ngClass]="{'logo-h-15': _service.getConfiguration('tenantGenericConfig')?.tenant === 'TFS'}"
                src="{{_service.getConfiguration('tenantGenericConfig')?.tenant === 'VOT' ? _service.getConfiguration('tenantGenericConfig')?.tenantLogo : _service.getConfiguration('tenantGenericConfig')?.tenantLogo+token}}">
              <div class="logo-container" *ngIf="_service.getConfiguration('tenantGenericConfig')?.tenant === 'IOC'">
                  <div class="logo">
                    <img src="../../../../assets/images/Indian_Oil_Logo2.svg" class="indian-oil-logo" alt="logo-indianoil"/>
                  </div>
                  <div class="text-box">
                    <div class="main-text">Indian Oil</div>
                    <div class="sub-text">The Energy of India</div>
                  </div>
              </div>
            </span>
          </div>
          <div class="rt-filter header-menu -mat-select-height-unset" *ngIf="!isDeveloperLiveShow">
            <mat-form-field appearance="outline">
              <mat-select [disableOptionCentering]="true" [(ngModel)]="selectedValue" name="item"
                (selectionChange)="siteChange($event)" class="-mat-select-mt-0">
                <mat-option *ngFor="let item of headerList" [value]="item">
                  {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="header-refresh-button uni-header-refresh-bt cursor" (click)="apiRefresh()">
            <span class="image-rotate"><img src="../../../../assets/images/header-api-refresh.svg"
                title="Refresh data in this page" class="h-14 cursor" alt="api refresh"></span><span
              class="inline-block mr-2 fw-refresh">Refresh</span>
          </div>
          <span class="blinking live-text-color title-for-swap-cards" *ngIf="isLiveStatus && _service.rbacManagement('home_LiveStatus')"><img alt="Live"
              matTooltip="Live" class="h-20" src="../../../../assets/images/live-photo.svg">&nbsp;Live
          </span>
          <span class=" go-live-title cursor" [ngClass]="{'blinking live-text-color': isDeveloperLive}"
            (click)="goBackLive()" *ngIf="isDeveloperLiveShow"><img alt="Live"
              [matTooltip]="isDeveloperLive? 'Live' : 'Go Live'" class="h-20"
              src="../../../../assets/images/live-photo.svg">&nbsp;{{isDeveloperLive? 'Live' : 'Go Live'}}
          </span>
        </a>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar3">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse w-100" id="collapsingNavbar3">
          <form class=" navbar-nav w-100 justify-content-center col-4 justify-content-center" role="search">
          </form>
          <ul class="nav navbar-nav ml-auto mt-0 w-100 justify-end navbar-right-login  make-responsive-headermenu">
            <li>
              <ul class="navbar-nav w-100 justify-content-center">
                <li title="Full Screen" *ngIf="!isFullScreen" class="d-flex align-items-end"><img
                    src="../../../../assets/images/fullView.svg" (click)="fullScreen()" class="h-30 cursor"
                    alt="full view">
                </li>
                <li title="Exit" *ngIf="isFullScreen" class="d-flex">
                  <img src="../../../../assets/images/Mini-view.svg" (click)="fullScreen()" class="h-30 cursor"
                    alt="full view" *ngIf="isFullScreen">
                </li>
              </ul>
            </li>
            <li class="nav-item disable" title="Notifications" (click)="captureNotification()"  *ngIf="_service.rbacManagement('home_Notifications')" class="cursor">
              <a class="nav-link posit position-relative p-0">
                <img src="../../../../assets/images/bell-icon-header.svg" class="h-21px" alt="blackbell"><sup
                  class="color-dot-sup2" *ngIf="notificationList?.length"></sup></a>
            </li>

            <li class="nav-item dropdown position-relative uni-profile-avatar-filter">
              <a [matMenuTriggerFor]="exportPop" #popTrigger="matMenuTrigger"
                (click)="popTrigger.openMenu();setUrl();getRole();" class="cursor pdl-15">
                <img src="../../../../assets/images/user-avatar-idec.svg" class="h-23px" alt="avatar">
              </a>
              <ng-container>
                <mat-menu #exportPop="matMenu" [hasBackdrop]="true">
                  <div class="d-flex flex-column profile-pop-wrapper " (click)="$event.stopPropagation();">
                    <div class="d-flex gap20">
                      <div class="avatar-wrapper uni-avatar-filter">
                        <img src="../../../../assets/images/user-avatar-idec.svg" class="h-100" alt="avatar">
                      </div>
                      <div class="d-flex flex-column justify-content-center">
                        <span class="user-name-pop">{{userFullName | titlecase}}</span>
                        <span style="color:#686071">{{roleName}}</span>
                      </div>
                    </div>
                    <div class="d-flex flex-column preference-container">
                      <div style="color:#797085">Preference</div>
                      <div class="d-flex justify-space-between">
                        <span>
                          <span>
                            <img src="../../../../assets/images/sound-profile-pop.svg" class="h-30" alt="Sound">
                          </span>
                          <span class="pop-label">Sound</span>
                        </span>
                        <span>
                          <mat-slide-toggle color="#055C7B" [checked]="isSocketSound" [disabled]="false"
                            (change)="socketSoundSettings()" class="uni-profile-pop" ></mat-slide-toggle>
                        </span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <span>
                          <span>
                            <img src="../../../../assets/images/notification-profile-pop.svg" class="h-30" alt="Bell">
                          </span>
                          <span class="pop-label">Notification</span>
                        </span>
                        <span>
                          <mat-slide-toggle color="#055C7B" [checked]="(isActive || isReconnecting)?true:false"
                            [disabled]="false" (change)="closeWebSocket()" class="uni-profile-pop"></mat-slide-toggle>
                        </span>
                      </div>
                    </div>
                    <div class="d-flex flex-column timezone-container">
                      <div class="d-flex justify-space-between">
                        <span>
                          <span>
                            <img src="../../../../assets/images/timezone-profile-pop.svg" class="h-30" alt="timezone">
                          </span>
                          <span class="pop-label">Timezone</span>
                        </span>
                        <span class="cursor" (click)="openTimeZoneModal();popTrigger.closeMenu();">
                          <span style="color:#797085">{{timeZone?.value}}&nbsp;&nbsp;</span>
                          <img src="../../../../assets/images/right-arrow-idec.svg" class="h-14" alt="open">
                        </span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <span>
                          <span>
                            <img src="../../../../assets/images/change-password-profile-pop.svg" class="h-30"
                              alt="timezone">
                          </span>
                          <span class="pop-label">Change Password</span>
                        </span>
                        <span class="cursor" (click)="changePassword();popTrigger.closeMenu();">
                          <img src="../../../../assets/images/right-arrow-idec.svg" class="h-14" alt="open">
                        </span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center flex-end">
                      <div class="cursor">
                        <button class="logout-button uni-logout-bt" (click)="logout()">
                          <img src="../../assets/images/logout_arrow.svg" alt="Logout" class="logout-icon" />
                          <span>LOGOUT</span>
                        </button>
                        
                      </div>
                    </div>
                  </div>
                </mat-menu>
              </ng-container>
              <p class="position-absolute right_0 d-flex updated-time-style me-0">{{refreshTime |
                date:'medium'}}&nbsp;&nbsp;{{timeZone?.value}}
              </p>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</div>

<ng-template let-data #timezonepopup>
  <div>
    Timezone
    <div>
      <mat-form-field>
        <mat-label>Choose an option</mat-label>
        <mat-select [formControl]="timeZone" (closed)="triggerEvent()" (focus)="clearDropDownSearch=false"
          [disableOptionCentering]="true" panelClass="mwPanel">
          <app-search-dropdown (searchItem)="searchTerm=$event" class="d-flex border-bottom mb-4"
            [clearSearch]="clearDropDownSearch">
          </app-search-dropdown>
          <mat-option class="text-capitalize"
            *ngFor="let timezone of timeZoneNames | commonSearch:searchTerm:'timezone'" [value]="timezone" selected>
            {{timezone}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="btn-basket">
      <button class="mat-primary mat-raised-button" mat-button mat-dialog-close>Cancel</button>
      <button class="mat-primary mat-raised-button" mat-button [mat-dialog-close]="true"
        (click)="timeZoneChanged()">Ok</button>
    </div>
  </div>
</ng-template>